import { BadgeSmallStyled } from 'approot/shared/badge/badge.style';
import { getAnswerTypeLabel } from 'approot/activity-builder/components/suggested-answers/logic/get-answer-type-label';
import {
  ClassroomAnswerInstruction,
  ClassroomSuggestedAnswer,
} from 'approot/activity-builder/classroom/classroom-answer.style';
import SubActivityView from 'approot/activity-builder/components/sub-activity/sub-activity-view';
import { ViewProps } from '../fill-in-blanks.constants';
import FillInBlanksViewAnswers from '../fill-in-blanks-view-answers';
import * as Styled from './fill-in-blanks-suggested-answers.style';

const FillInBlanksSuggestedAnswers = (props: ViewProps) => {
  const { subActivityProperties, suggestedAnswerProperties } = props;

  return (
    <ClassroomAnswerInstruction>
      <SubActivityView subActivityDetails={subActivityProperties}>
        <ClassroomSuggestedAnswer>
          <Styled.FillInBlanksSuggestedAnswers>
            <FillInBlanksViewAnswers
              {...props}
              fieldAnswers={suggestedAnswerProperties?.suggestedAnswers}
            />
          </Styled.FillInBlanksSuggestedAnswers>
          {suggestedAnswerProperties?.suggestedAnswerType && (
            <BadgeSmallStyled>
              {getAnswerTypeLabel(
                suggestedAnswerProperties?.suggestedAnswerType
              )}
            </BadgeSmallStyled>
          )}
        </ClassroomSuggestedAnswer>
      </SubActivityView>
    </ClassroomAnswerInstruction>
  );
};

export default FillInBlanksSuggestedAnswers;
